// extracted by mini-css-extract-plugin
module.exports = {"section":"TryNow_section__6YBYW","title":"TryNow_title__mf0Rz","description":"TryNow_description__6wF6D"};